<template>
  <layout-main-inner
    v-loading="loading"
    :title="$route.meta.name">
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.idName"
          clearable
          placeholder="请输入用户姓名"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          fixed="left"
          label="ID"
          min-width="130"
          prop="id"> </el-table-column>
        <el-table-column
          label="用户姓名"
          fixed="left"
          min-width="90"
          prop="idName">
        </el-table-column>
        <el-table-column
          label="手机号"
          min-width="110"
          prop="mobilePhone"></el-table-column>
        <el-table-column
          label="身份证号"
          prop="idNo"
          min-width="160"></el-table-column>
        <el-table-column
          label="职业"
          min-width="120"
          prop="work"> </el-table-column>
        <el-table-column
          label="核验机构"
          prop="verificationCorpName"
          min-width="160"></el-table-column>
        <el-table-column
          label="核验时间"
          min-width="140">
          <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          label="涉网风险情况"
          min-width="100">
          <template slot-scope="{ row }">
            <span :style="getStyle(row.publicSecIdVerificationResult)">{{ row.publicSecIdVerificationResult | getResult(row.publicSecIdVerificationResultInfo) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="失信限高情况"
          min-width="100">
          <template slot-scope="{ row }">{{ row.judicialVerificationResult | getResult(row.judicialVerificationResultInfo) }}</template>
        </el-table-column> -->
        <el-table-column
          label="涉诉情况"
          min-width="210">
          <template slot-scope="{ row }">
            <span :style="getStyle(row.lawCaseVerificationResult)">{{ row.lawCaseVerificationResult | getResult(row.lawCaseVerificationResultInfo) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          :width="80">
          <template slot-scope="{ row }">
            <el-button
              :disabled="!row.judicialCases"
              type="text"
              @click="viewItem(row)">查看案件</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </layout-card-wrap>

    <history-detail-drawer ref="history" />
  </layout-main-inner>
</template>
<script>
import Verification from '@/service/verification'
import HistoryDetailDrawer from './busi/history-detail-drawer.vue'
const mapData = { 1: '核验中', 5: '身份证号不正确', 9: '正常' } // 1，核验中；5，身份证号不正确；9，正常；13，异常；17，失败
export default {
  name: 'VerificationList',
  components: { HistoryDetailDrawer },
  filters: {
    getResult(val, val1) {
      return mapData[val] || val1
    }
  },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, idName: '' }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    getStyle(val) {
      const map = { 1: '', 5: '', 9: '#67c23a', 13: '#f56c6c', 17: '' }
      return { color: map[val] }
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Verification.getverificationorders({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, total, records } = res.data
          if ([0].includes(result)) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    viewItem(row) {
      console.log(row)
      this.$refs.history.init(row)
      // this.$message.error('暂无信息')
    }
  }
}
</script>
